import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import Footer from "../../components/layout/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAnimateCss, { useAnimateCssStagger } from "../../hooks/useAnimateCss";
import headerImg from "../../assets/images/background/13a.jpg";
import sideImg from "../../assets/images/misc/steel-rebar-2.webp";

function FaqGroup({ title, items }: { title: string; items: { q: string; a: string }[] }) {
  return (
    <div className="faqs-group">
      <h2 className="faqs-group-title">{title}</h2>
      <div className="faqs-group-divider" />
      <div className="faq-accordion">
        {items.map((item, i) => (
          <details key={i} className="faq-item">
            <summary className="faq-item-summary">
              <span className="faq-item-question">{item.q}</span>
              <span className="faq-item-icon">
                <svg className="faq-icon-minus" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 15.345h32v2.11h-32v-2.11z" />
                </svg>
                <svg className="faq-icon-plus" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                  <path d="M32 15.345h-14.945v-14.945h-2.11v14.945h-14.945v2.11h14.945v14.945h2.11v-14.945h14.945z" />
                </svg>
              </span>
            </summary>
            <div className="faq-item-body">{item.a}</div>
          </details>
        ))}
      </div>
    </div>
  );
}

function Faqs() {
  const { t } = useTranslation();
  const eyebrowRef    = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const headRef       = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const accordionRef  = useAnimateCssStagger("animate__fadeInLeft", 90, 0.08);
  const imgRef        = useAnimateCss("animate__zoomIn",     0,   0.15, 700);
  const ctaRef        = useAnimateCss("animate__fadeInUp",   200, 0.15);

  const generalFaqs = [
    { q: t("faqs-gen-1-q"), a: t("faqs-gen-1-a") },
    { q: t("faqs-gen-2-q"), a: t("faqs-gen-2-a") },
    { q: t("faqs-gen-3-q"), a: t("faqs-gen-3-a") },
    { q: t("faqs-gen-4-q"), a: t("faqs-gen-4-a") },
    { q: t("faqs-gen-5-q"), a: t("faqs-gen-5-a") },
  ];

  const technicalFaqs = [
    { q: t("faqs-tech-1-q"), a: t("faqs-tech-1-a") },
    { q: t("faqs-tech-2-q"), a: t("faqs-tech-2-a") },
    { q: t("faqs-tech-3-q"), a: t("faqs-tech-3-a") },
    { q: t("faqs-tech-4-q"), a: t("faqs-tech-4-a") },
    { q: t("faqs-tech-5-q"), a: t("faqs-tech-5-a") },
  ];

  return (
    <>
      <MainHeader />
      <PageHeader image={headerImg} title={t("FAQs")} />

      <section className="faq-section">
        <div className="container">
          <div className="faq-header">
            <span className="faq-eyebrow" ref={eyebrowRef as any}>{t("faqs-eyebrow")}</span>
            <h2 className="faq-main-heading" ref={headRef as any}>{t("faqs-main-heading")}</h2>
          </div>

          <div className="row g-5 align-items-start">
            {/* LEFT — two accordion groups */}
            <div className="col-lg-7" ref={accordionRef as any}>
              <FaqGroup title={t("faqs-general-title")}   items={generalFaqs}   />
              <FaqGroup title={t("faqs-technical-title")} items={technicalFaqs} />
            </div>

            {/* RIGHT — sticky image + CTA */}
            <div
              className="col-lg-5 faq-right-col"
              style={{ paddingLeft: "50px", paddingRight: "50px" }}
            >
              <img src={sideImg} alt="Al Madina Steel" className="faq-side-img" ref={imgRef as any} />
              <div className="faq-still-box" ref={ctaRef as any}>
                <h4 className="faq-still-heading">{t("faq-still")}</h4>
                <Link to="/about" className="btn-primary-custom">
                  {t("Contact Us")} &nbsp;<i className="bi bi-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Faqs;
